// Dependencies
import React from 'react';
import radium from 'radium';
import { connect } from 'react-redux';
import TicketAddressForm from './TicketAddressForm.jsx';
import TicketAddressFormHeadline from './TicketAddressFormHeadline.jsx';
import ZigZagBox from '../../../components/zig-zag-box/ZigZagBox.jsx';
import ZigZagBoxTitle from '../../../components/zig-zag-boxTitle/ZigZagBoxTitle.jsx';

// Styles
import './TicketAddressZone.scss';
import {ThemeContext} from "../../../components/theme/Theme.jsx";

class TicketAddressZone extends React.Component {

	getTicketAddressErrorsPerTicketItemUuid(ticketItemUuid) {
		const errors = this.props.ticketAddressErrors[ticketItemUuid] ? this.props.ticketAddressErrors[ticketItemUuid] : [];
		return errors;
	}

	render() {
		return (this.props.ticketAddressDataElements.length > 0) ? (
			<ZigZagBox id={"ticket-addresses"}>
				<ZigZagBoxTitle headlineLevel={"h2"}>
					{this.context.themeManager.getThemeTextOrHardcodedDefault('ticketAddressHeadline')}
				</ZigZagBoxTitle>
				<div
					className="ticket-address__info-container"
					dangerouslySetInnerHTML={{ __html: this.context.themeManager.getThemeText('ticketAddressInfoText') }}
				/>
				{ this.props.ticketAddressDataElements.map((element, index) => (
					<div key={index.toString()} className="ticket-address__form">
						<TicketAddressFormHeadline
							displayTicket={element.displayTicket}
						/>
						<TicketAddressForm
							index={index.toString()}
							autoCompleteType="ticket-address"
							address={element.address}
							ticketItemUuid={element.displayTicket.ticketItemUuid}
							errors={this.getTicketAddressErrorsPerTicketItemUuid(element.displayTicket.ticketItemUuid)}
						/>
					</div>
				))}
			</ZigZagBox>
		) : null;
	}
}

TicketAddressZone.contextType = ThemeContext;

const RadiumTicketAddressZone = radium(TicketAddressZone);

// ------------------------------
// Store Connection
// ------------------------------

const mapStateToProps = (state) => {
	const showTicketAddressData = state.ticketAddress.showTicketAddressData;
	const ticketAddressData = state.ticketAddress.data;
	const ticketAddressDataElements = Object.keys(ticketAddressData).map(key => ticketAddressData[key]);
	const ticketAddressErrors = state.ticketAddress.errors;
	return {
		ticketAddressDataElements,
		showTicketAddressData,
		ticketAddressErrors,
	};
};

export default connect(
	mapStateToProps,
)(RadiumTicketAddressZone);
